const videoFrame = (url) =>{
    const urlObj = new URL(url);
    const host = urlObj.hostname;

    if (host.includes('facebook.com') || host.includes('fb.watch')) {
        generateFacebookVideoEmbed(url)
    }
    if (host.includes('youtube.com')){
        videoStorefront(url)
    }
}

function loadScript(url) {
    return new Promise((resolve, reject) => {
        // Verificar si el script ya está cargado
        if (document.querySelector(`script[src="${url}"]`)) {
            resolve();
            return;
        }

        const script = document.createElement("script");
        script.src = url;
        script.type = "text/javascript";
        script.defer = true;

        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Error al cargar el script: ${url}`));

        document.head.appendChild(script);
    });
}

const videoStorefront = (urlVideo) => {
    const slidesStorefront = document.getElementById("slidesStorefront");
    slidesStorefront.classList.add('skeleton')
    const parentBento = document.getElementById("storefrontVideoHome");
    parentBento.style.display = 'none'
    
    const regex = /(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/|m\.youtube\.com\/watch\?v=)([a-zA-Z0-9_-]{11})/;
    const match = urlVideo.match(regex);
    
    if (match && match[1]) {
        const divContentSlide = document.createElement('div');
        divContentSlide.classList.add('slideshow__slide', 'js-overflow-container', 'section--image');
        const videoId = match[1];

        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${videoId}`;
        iframe.width = '100%';
        iframe.height = '100%';
        iframe.frameBorder = '0';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;

        divContentSlide.append(iframe);
        parentBento.prepend(divContentSlide);

        iframe.onload = () => {
            parentBento.style.display = '';
            slidesStorefront.classList.remove('skeleton');
        };
    }
};

const generateFacebookVideoEmbed = (url) => {
    const slidesStorefront = document.getElementById("slidesStorefront");
    slidesStorefront.classList.add('skeleton')
    const parentBento = document.getElementById("storefrontVideoHome");
    parentBento.style.display = 'none'
    const divContentSlide = document.createElement('div');
    divContentSlide.classList.add('slideshow__slide', 'js-overflow-container', 'section--image', 'video-facebook-sectionslide');
    
    try {
        const urlObj = new URL(url);
        const host = urlObj.hostname;
        const path = urlObj.pathname;

        if (!host.includes('facebook.com') && !host.includes('fb.watch')) return null;

        let videoUrl = null;

        const videoRegex = /^\/([^\/]+)\/videos\/(\d+)\/?$/;
        const match = path.match(videoRegex);
        if (match) videoUrl = url;

        const postRegex = /^\/([^\/]+)\/posts\/(\d+)\/?$/;
        const postMatch = path.match(postRegex);
        if (postMatch) videoUrl = `https://www.facebook.com/${postMatch[1]}/videos/${postMatch[2]}`;

        if (urlObj.searchParams.has('v')) {
            const videoId = urlObj.searchParams.get('v');
            videoUrl = `https://www.facebook.com/watch/?v=${videoId}`;
        }

        if (host.includes('fb.watch')) return null;
        if (!videoUrl) return null;

        const videoContainer = document.createElement('div');
        videoContainer.className = 'fb-video';
        videoContainer.setAttribute('data-href', videoUrl);
        videoContainer.setAttribute('data-width', '800');
        videoContainer.setAttribute('data-autoplay', 'true');
        videoContainer.setAttribute('data-allowfullscreen', 'true');
        videoContainer.setAttribute('data-lazy', 'false');
        videoContainer.style.width = '100%';
        videoContainer.style.height = '100%';

        divContentSlide.append(videoContainer);
        parentBento.prepend(divContentSlide);

        // Cargar el SDK si no está disponible
        loadScript("https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v18.0")
            .then(() => {
                if (window.FB) {
                    window.FB.Event.subscribe('xfbml.ready', (msg) => {
                        if (msg.type === 'video') {
                            parentBento.style.display = 'block'
                            slidesStorefront.classList.remove('skeleton')
                        }
                    });
                    // Forzar el parseo de Facebook
                    window.FB.XFBML.parse(divContentSlide);
                }
            })
            .catch((err) => console.error("Error loading SDK de Facebook:", err));

    } catch (error) {
        console.error("Error with URL:", error);
        return null;
    }
};

document.addEventListener("theme:partner:set", (event) => {
    const url_video = event.detail.partner.url_video
    videoFrame(url_video)    
});